type StatusViewProps = {
	containerClassName: string;
	containerStyle?: { backgroundColor?: string };
	title?: string;
	description?: string;
	message?: string;
};

export function StatusView({
	containerClassName,
	containerStyle,
	title,
	description,
	message,
}: StatusViewProps) {
	return (
		<div
			className={`min-h-screen flex items-center justify-center p-4 ${containerClassName}`}
			style={containerStyle}
		>
			<div className="w-full max-w-sm">
				{message ? (
					<div className="text-center">{message}</div>
				) : (
					<div className="text-center">
						{title && <h1 className="text-2xl mb-4">{title}</h1>}
						{description && (
							<p className="text-base opacity-80">{description}</p>
						)}
					</div>
				)}
			</div>
		</div>
	);
}
